var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileHamburger = function SvgMobileHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.5C7.55964 3.5 7 4.05964 7 4.75C7 5.44036 7.55964 6 8.25 6H23.75C24.4404 6 25 5.44036 25 4.75C25 4.05964 24.4404 3.5 23.75 3.5H8.25ZM0 13C0 12.3096 0.559644 11.75 1.25 11.75H23.75C24.4404 11.75 25 12.3096 25 13C25 13.6904 24.4404 14.25 23.75 14.25H1.25C0.559644 14.25 0 13.6904 0 13ZM12 21.25C12 20.5596 12.5596 20 13.25 20H23.75C24.4404 20 25 20.5596 25 21.25C25 21.9404 24.4404 22.5 23.75 22.5H13.25C12.5596 22.5 12 21.9404 12 21.25Z",
    fill: "currentColor"
  })));
};
export default SvgMobileHamburger;